module.exports = __webpack_public_path__ + "media/images/covid/menu/outgoing-a97a1a744d8c9c7b7d7661c66d4b3f2f.png";